import { formatNumber, translate } from "@/i18n";
import { desktopScreenRecordingMessages } from "@/i18n/messages/desktop-screen-recording";

export type ClipPhase =
  | "starting"
  | "recording"
  | "processing"
  | "ready"
  | "error";

/** A clip's one-line state, shared by the live clip card and its showcase. */
export function screenRecordingClipLabel(clip: {
  number: number;
  phase: ClipPhase;
  elapsedSeconds: number;
  durationMs: number;
  error?: string;
  status: boolean;
}): string {
  const m = desktopScreenRecordingMessages;
  const number = clip.number;
  if (clip.phase === "starting")
    return translate(m, "clipStarting", { number });
  if (clip.phase === "recording")
    return translate(m, "clipRecording", {
      number,
      seconds: formatNumber(clip.elapsedSeconds),
    });
  if (clip.phase === "processing")
    return translate(m, "clipSaving", { number });
  if (clip.phase === "error")
    return translate(m, "clipFailed", {
      number,
      error: clip.error || translate(m, "recordingFailed"),
    });
  return translate(m, clip.status ? "clipSaved" : "clipDuration", {
    number,
    seconds: formatNumber(clip.durationMs / 1_000, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }),
  });
}
